import { OrderedMap, fromJS } from 'immutable';
import UserEventListActions from 'flux/actions/UserEventListActions';
import TeamEventListActions from 'flux/actions/TeamEventListActions';
import Pagination from 'shared/constants/Pagination';

export default {
  populatePaginationState(page, pageNumber) {
    let items = OrderedMap(
      page.items.map((item) => {
        return [item._id, fromJS(item)];
      }),
    );

    let next = this.getState()
      .set(Pagination.PAGE_ITEMS_KEY, items)
      .set(Pagination.TOTAL_ITEMS_KEY, page.itemCount)
      .set(Pagination.TOTAL_PAGES_KEY, page.pageCount);

    if (pageNumber) next = next.set(Pagination.PAGE_KEY, pageNumber);

    return next;
  },

  onPage(pageNumber) {
    this.setInStateAndTrigger(Pagination.PAGE_KEY, pageNumber);

    const populate = {
      path: 'shows',
      select: '_id title deleted archived saved template displayType',
    };

    let filterQuery = this.getInState('filterQuery')
      ? this.getInState('filterQuery').toJS()
      : null;

    if (!filterQuery) return;

    let query = Object.assign(
      { page: pageNumber, size: Pagination.PAGE_SIZE, populate },
      filterQuery,
    );

    if (this.getInState('teamId')) {
      TeamEventListActions.getPage(this.getInState('teamId'), query);
    } else {
      let user = this.getInState('user');
      if (!user) {
        return;
      }
      UserEventListActions.getPage(user.get('_id'), query);
    }
  },
};
